import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTubePurpleCap = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 72,
	height: 184,
	viewBox: "0 0 72 184",
	xmlns: "http://www.w3.org/2000/svg",
	role: "img",
	"aria-label": "Purple cap blood tube",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M20 44 H52 V150 a16 16 0 0 1 -32 0 Z",
			fill: "#eef2f6",
			stroke: "#b9c2cc",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 24,
			y: 74,
			width: 24,
			height: 70,
			rx: 2,
			fill: "#ffffff",
			stroke: "#d5dbe2",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 16,
			y: 8,
			width: 40,
			height: 44,
			rx: 5,
			fill: "#7e5aa6",
			stroke: "#563a77",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsxs("g", {
			stroke: "#563a77",
			strokeWidth: 1.5,
			opacity: .55,
			children: [
				/* @__PURE__ */ _jsx("line", {
					x1: 25,
					y1: 14,
					x2: 25,
					y2: 46
				}),
				/* @__PURE__ */ _jsx("line", {
					x1: 33,
					y1: 14,
					x2: 33,
					y2: 46
				}),
				/* @__PURE__ */ _jsx("line", {
					x1: 41,
					y1: 14,
					x2: 41,
					y2: 46
				}),
				/* @__PURE__ */ _jsx("line", {
					x1: 49,
					y1: 14,
					x2: 49,
					y2: 46
				})
			]
		})
	]
});
export default SvgTubePurpleCap;
